export const validateFileSize = (file) => {
  const FILE = file[0]
  const sizeLimit = 5 * 1024 * 1024 // 5MB
  if (!FILE?.size) return 'This field is Required'
  if (FILE.size > sizeLimit)
    return "Sorry, the file you're attaching is larger than our system allows. Please limit each attachment to 5MB"
  return 'success'
}
